var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.3551 85.3553C104.881 65.8291 104.881 34.1709 85.3551 14.6447C65.8289 -4.88155 34.1706 -4.88156 14.6444 14.6447C-4.88181 34.1709 -4.88181 65.8291 14.6444 85.3553C34.1706 104.882 65.8289 104.882 85.3551 85.3553Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1129 12.2117C47.678 10.4446 54.7102 10.4672 61.2934 12.144C67.4297 13.7057 73.1779 16.7051 77.7998 21.0314C74.1302 24.7484 70.4087 28.4293 66.6127 32.0176C61.6906 27.3302 54.4169 25.2539 47.687 26.4297C39.0343 27.6981 31.5845 34.1797 28.8335 42.293C24.5071 38.9822 20.1266 35.7392 15.8838 32.3268C18.8605 26.502 23.3832 21.4602 28.8335 17.7568C32.5572 15.2269 36.7166 13.3198 41.1129 12.214V12.2117Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8561 67.4408C13.0531 62.056 11.6539 56.0303 11.6426 50.0001C11.6336 43.8908 13.0509 37.7771 15.8832 32.3246C20.126 35.7392 24.5088 38.98 28.8329 42.2907C27.0477 47.2061 27.1199 52.6541 28.8058 57.5852C24.4862 60.8644 20.1644 64.1436 15.8561 67.4386V67.4408Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2793 42.5751C56.3933 42.5796 61.5072 42.5796 66.6212 42.5773C73.9649 42.5773 81.3109 42.5728 88.6569 42.5864C89.8236 49.2056 89.6205 56.2063 87.7902 62.7195C86.4813 67.3753 84.3418 71.7829 81.2793 75.624C80.0832 76.9511 78.9029 78.2961 77.6255 79.5419C73.4255 76.3869 69.0947 73.1145 65.0121 69.8195C65.8719 69.1831 66.734 68.2668 67.56 67.2219C70.5391 63.4552 73.0283 58.0208 73.0283 58.0208C73.0283 58.0208 70.1125 57.8245 68.6591 57.8087C62.8952 57.8087 57.1312 57.8245 51.3651 57.8041C51.3109 52.7263 51.4531 47.6484 51.2816 42.5751H51.2793Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8064 57.5874C31.2799 64.5475 37.0235 70.334 44.1935 72.6156C51.0655 74.7303 59.0411 73.8794 65.0082 69.8194C69.0908 73.1144 73.4239 76.3868 77.6216 79.5418C69.7927 86.4996 59.0366 89.596 48.5853 88.8422C41.5868 88.3367 34.7261 86.1069 28.9757 82.1552C23.3765 78.5014 18.8741 73.3197 15.8545 67.4407C20.1628 64.1457 24.4846 60.8666 28.8042 57.5874H28.8064Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.77129970a4fddab616f00de55d1c615b.svg";
export { ForwardRef as ReactComponent };